import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field } from "redux-form";
import { renderFieldText, renderHiddenFieldText } from "@basecomponent";
import ImageCropper from "@imagecropper";
import LocaleStrings from "@language";

const CompanyFixedFields = (props) => {
  const { formValues, checkoutFormData } = props;

  const onLogoSave = (img) => {
    props.autofill("companylogo", img === "" ? "" : img);
  };

  const onBannerSave = (img) => {
    props.autofill("companybanner", img === "" ? "" : img);
  };
  let formType =
    checkoutFormData?.data?.appuser_groups_by_formid?.[0]?.type ?? "";

  return (
    <div className="space-y-6">
      {/* Logo + Text Fields */}
      <div className="flex flex-col md:flex-row md:space-x-6 justify-between">
        {/* Logo */}
        <div className="flex-shrink-0">
          <label className="control-label-top block mb-2">
            {LocaleStrings.kUploadLogoText}
          </label>
          <ImageCropper
            displaySize={{ width: 200, height: 200 }}
            requiredSize={{ width: 300, height: 300 }}
            cropperSize={{ width: 180, height: 180 }}
            onImageSave={onLogoSave}
            imagepath={formValues?.logo ?? ""}
            border={10}
            displayText={LocaleStrings.kFileDragDropText}
            fileSizeText={LocaleStrings.kFileMinSizeText}
            imageType="jpg"
            baseClassName="COMPANY_LOGO_IMG"
          />
          <Field
            name={`companylogo`}
            type="text"
            component={renderHiddenFieldText}
          />
        </div>
        {/* Banner */}
        <div>
          <label className="control-label-top block mb-2">
            {LocaleStrings.kUploadBannerText}
          </label>
          <ImageCropper
            displaySize={{ width: 308, height: 200 }} // For image display style
            requiredSize={{ width: 566, height: 368 }} // For image size required validation
            cropperSize={{ width: 277, height: 180 }} // Cropper display size.
            onImageSave={onBannerSave}
            imagepath={formValues?.banner ?? ""}
            border={10}
            displayText={LocaleStrings.kFileDragDropText}
            fileSizeText={LocaleStrings.kFileMinSizeText}
            imageType="jpg"
            baseClassName="COMPANY_BANNER_IMG"
          />
          <Field
            name={`companybanner`}
            type="text"
            component={renderHiddenFieldText}
          />
        </div>
      </div>
      {/* Name & About */}
      <div className="flex-1 mt-4 md:mt-0 space-y-4">
        <Field
          name={`companyname`}
          label={
            formType === "exhibitor"
              ? LocaleStrings.kCompanyNameText
              : LocaleStrings.kCompanyNameText
          }
          placeholder=""
          type="text"
          component={renderFieldText}
          mandatory={true}
        />
        <Field
          name={`companyabout`}
          label={LocaleStrings.kAbout}
          placeholder=""
          type="text"
          component={renderFieldText}
          mandatory={false}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  checkoutFormData: state.checkoutFormData,
  formValues: state.formValues, // adjust key based on your redux structure
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CompanyFixedFields);
